import './RecommendedProductsA.scss';

import { b2x } from '@b2x/react/src';
import classnames from 'classnames';

import { Button } from './Button';
import { ComponentWrapper } from './ComponentWrapper';
import { RecommendedProductsContentType } from './contentTypes';
import { t } from './i18n/i18n';
export interface RecommendedProductsAProps {
  contentCode: string;
}

export const RecommendedProductsA = ({ contentCode }: RecommendedProductsAProps) => {
  const content = b2x.useContent<RecommendedProductsContentType>(contentCode);

  return (
    <ComponentWrapper
      classNames="recommended-products-a"
      options={{
        ...content?.body.options,
        container: {
          enabled: true,
          size: 'always',
        },
        margin: {
          bottom: content?.body.options?.margin?.bottom,
          top: undefined,
        },
        padding: {
          bottom: undefined,
          top: undefined,
        },
      }}
    >
      <b2x.Row alignItems={'center'}>
        <b2x.Col className="left-col" size={{ md: '', xs: 12 }}>
          <b2x.Div className="position-relative" marginBottom={{ md: 0, xs: 5 }}>
            {content?.body.leftCol?.asset && <b2x.AssetV2 {...content.body.leftCol.asset} className="w-100" />}
            <b2x.Div
              className="position-absolute bottom-0 start-0 w-100 text-white title-container"
              display={'flex'}
              justifyContent={'center'}
              paddingX={3}
              paddingY={5}
              textAlign={'center'}
            >
              <p className={'h1 m-0 lh-1'}>{content?.body.leftCol?.title?.toUpperCase()}</p>
            </b2x.Div>
          </b2x.Div>
        </b2x.Col>
        <b2x.Col className="right-col" size={{ md: '', xs: 12 }}>
          <b2x.Div className="inner-container" paddingStart={{ md: 4 }}>
            {content?.body.rightCol?.productsIds && (
              <b2x.ProductsByIds
                ids={content.body.rightCol.productsIds.map(({ id }) => id)}
                key={content.body.rightCol.productsIds.map(({ id }) => id).join('')}
              >
                {(products) => (
                  <b2x.Listing name="Recommended products - A" products={products}>
                    <b2x.SwiperContext>
                      {({ navigationNextElRef, navigationPrevElRef }) => (
                        <b2x.Div className="position-relative">
                          <b2x.EqualHeight>
                            <b2x.Swiper
                              breakpoints={{
                                lg: {
                                  slidesPerView: 1.15,
                                },
                                xl: {
                                  slidesPerView: 2.15,
                                },
                                xs: {
                                  slidesPerView: 1.15,
                                },
                                xxl: {
                                  slidesPerView: 3.15,
                                },
                              }}
                              navigation={{ custom: true }}
                              slides={products?.map((_product) => (
                                <b2x.ProductTile alternativeImageFirst key={_product.id} product={_product} />
                              ))}
                              slidesPerView={1.15}
                              spaceBetween={8}
                            />
                          </b2x.EqualHeight>
                          <b2x.Div
                            alignItems={'center'}
                            display={{ lg: 'flex', xs: 'none' }}
                            justifyContent={'end'}
                            padding={3}
                            style={{ pointerEvents: 'none', zIndex: 100 }}
                          >
                            <Button
                              aria-label={t('accessibility.button.swiper_prev')}
                              className={classnames({
                                'd-none': navigationPrevElRef.current?.disabled,
                              })}
                              iconStart={{ name: 'arrow-left', size: 40 }}
                              innerRef={navigationPrevElRef}
                              style={{ pointerEvents: 'initial' }}
                              variant="blank"
                            />
                            <Button
                              aria-label={t('accessibility.button.swiper_next')}
                              className={classnames({
                                'd-none': navigationNextElRef.current?.disabled,
                              })}
                              iconStart={{ name: 'arrow-right', size: 40 }}
                              innerRef={navigationNextElRef}
                              style={{ pointerEvents: 'initial' }}
                              variant="blank"
                            />
                          </b2x.Div>
                        </b2x.Div>
                      )}
                    </b2x.SwiperContext>
                  </b2x.Listing>
                )}
              </b2x.ProductsByIds>
            )}
          </b2x.Div>
        </b2x.Col>
      </b2x.Row>
    </ComponentWrapper>
  );
};
